import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getToken } from './api';

export default function AdminProtected() {
  const token = getToken();
  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }
  return <Outlet />;
}
